import { initComponentStore, noop } from "@/utils/mobx";

export class MdPreviewStore {
    html: string = "";
    fontSize: number = 14;
    onFontSizeChange: (size: number) => void = noop;

    constructor() {
        initComponentStore(this);
    }
}
